<h2 mat-dialog-title>
  @if (isEdit) {
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
    Rediger bruger
  } @else {
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#user-add-s"></use></svg>
    Opret bruger
  }
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<form [formGroup]="userFormGroup" (ngSubmit)="saveUser()">
  <mat-dialog-content>
    @if (userFormGroup) {
      <div [formGroup]="userFormGroup" class="form-row">
        <adm-org-typeahead
          [initialId]="data.organizationId ? data.organizationId : undefined"
          [resetTrigger]="resetOrgTrigger()"
          [disabled]="isEdit"
          (itemSelected)="organizationSelected($event)"
          (clearTypeAhead)="resetOrganization()" />
      </div>
    }
    <div class="form-row">
      <mat-form-field>
        <mat-label>Email adresse</mat-label>
        <input
          matInput
          placeholder="Brugerens email adresse"
          maxlength="75"
          formControlName="emailAddress"
          required
          [email]="true"
          value="" />
        @if (userFormGroup.controls.emailAddress) {
          <mat-error>{{ getErrorMessage('emailAddress') }}</mat-error>
        }
        @if (!isEdit) {
          <mat-hint>Email adresse fungerer som brugernavn</mat-hint>
        }
        @if (isEdit) {
          <mat-hint>Email adrressen kan ikke ændres, da den fungerer som brugernavn</mat-hint>
        }
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field>
        <mat-label>Navn</mat-label>
        <input matInput placeholder="Navn på brugeren" maxlength="75" formControlName="name" required value="" />
        @if (!userFormGroup.controls.name.valid) {
          <mat-error>{{ getErrorMessage('name') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-label>Rolle</mat-label>
      <mat-radio-group formControlName="selectedRole">
        @for (role of userRoles; track role.id) {
          <mat-radio-button [value]="role" [checked]="role.id === selectedRole?.id">
            {{ role.description }}
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (!userFormGroup.controls.selectedRole.valid) {
        <mat-error>{{ getErrorMessage('selectedRole') }}</mat-error>
      }
      @if (!isEdit) {
        <ok-feedback-info>
          <div>
            <strong>Oprettelse af bruger</strong>
            <br />
            Efter oprettelse vil brugeren modtage en velkomst e-mail hvori brugeren får mulighed for at tilgå portalen og oprette et
            personligt kodeord
          </div>
        </ok-feedback-info>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" mat-button mat-dialog-close>Annuller</button>
    <button
      class="actions__button"
      type="submit"
      mat-flat-button
      color="primary"
      [disabled]="saving || userFormGroup.invalid || !isOrganizationValid"
      [class.spinner]="saving">
      Gem
    </button>
  </mat-dialog-actions>
</form>
